import * as React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { CustomDisabledTextfield, CustomTextField } from "../../Components/custom-textfield/CustomTextField";
import { useState } from "react";
import * as CustomerService from '../../Services/customer-service';
import HeaderCustomer from "../../Layouts/header/HeaderCustomer";
import '../../Assets/Styles/Customer/LoginCustomer.css';
import '../../Assets/Styles/Customer/customer.css';
import '../../Assets/Styles/Customer/font-size.css';
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import InfoPopup from "../../Components/custom-popup/InfoPopup";
export default function LoginCustomer({ objectDto, setObjectDto, setLoading, setState }) {
    const [login, setLogin] = useState(objectDto !== null ? { 'username': objectDto.poIdNumber, 'password': objectDto.password } : { 'username': "", 'password': '' });
    const { i18n } = useTranslation();
    useEffect(() => {
    }, [i18n]);
    return (
        <>
            <HeaderCustomer />
            <div className="container-login-customer">
                <div className="box-login-right">
                    <span className="customer-title customer-color">{t("titleLoginCustomer1")}<br /><p className="customer-title-bold">{t("titleLoginCustomer2")}</p></span>
                    <Box className="box-login">
                        {
                            objectDto.otp === undefined || objectDto.otp === "" ?
                                <>
                                    <CustomTextField className="css-textfield-login" margin="normal" fullWidth id="username" focusColor="#c4960c"
                                        placeholder={"Căn cước/ CCCD/ Hộ chiếu"} size="small" name="username"
                                        autoComplete="username" autoFocus value={login.username ?? ""}
                                        sx={{
                                            backgroundColor: "white",
                                            "&.MuiTextField-root": {
                                                marginTop: "5px", marginBottom: "0px"
                                            }
                                        }}
                                        onChange={(e) => { e.target.value !== "" ? setLogin({ ...login, username: e.target.value }) : setLogin({ ...login, username: "" }) }}
                                        onKeyDown={(e) => e.keyCode === 13 ?
                                            (
                                                document.getElementById("password").focus()
                                            ) : null}
                                    />
                                    <CustomTextField className="css-textfield-login" margin="normal" fullWidth focusColor="#c4960c" size="small" name="password"
                                        placeholder={"Mật khẩu"} id="password" value={login.password ?? ""} autoComplete="password"
                                        sx={{ backgroundColor: "white", "&.MuiTextField-root": { marginTop: "5px", marginBottom: "5px" } }} type="password"
                                        onChange={(e) => {
                                            setLogin({ ...login, password: e.target.value })
                                        }}
                                        onKeyDown={(e) => e.keyCode === 13 ?
                                            (
                                                setLoading(true),
                                                CustomerService.verifyLogin(login.username, login.password, setObjectDto, setLoading, setLogin)
                                            ) : null} />
                                </>
                                :
                                <>
                                    <CustomDisabledTextfield className="css-textfield-login" variant="outlined" label={""} size="small" fullWidth disabled value={login.username}
                                        sx={{
                                            "&.MuiTextField-root": { marginTop: "5px", marginBottom: "5px" },
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                backgroundColor: "white",
                                                WebkitTextFillColor: "gray"
                                            }
                                        }} />
                                    <CustomDisabledTextfield className="css-textfield-login" variant="outlined" label={""} size="small" fullWidth disabled value={login.password}
                                        sx={{
                                            "&.MuiTextField-root": { marginTop: "5px", marginBottom: "5px" },
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                backgroundColor: "white",
                                                WebkitTextFillColor: "gray"
                                            }
                                        }}
                                    />
                                </>
                        }
                        <Button variant="contained" className="css-button-login" component="label" fullWidth
                            onClick={() => {
                                setLoading(true);
                                CustomerService.verifyLogin(login.username, login.password, setObjectDto, setLoading, setLogin);
                            }}
                            sx={objectDto.otp !== undefined && objectDto.otp !== "" ? { display: "none" } : {
                                textAlign: "center", borderRadius: "5px", fontWeight: 500, backgroundColor: "#DFB246", color: "white", mb: 1,
                                ":hover": { backgroundColor: "#c99b13", fontWeight: 1000 }
                            }}>
                            <span className="css-button-login">{t("login")}</span>
                        </Button>
                        <span>
                            <button className="button-register" variant="text" onClick={() => {
                                setState("1");
                                localStorage.setItem("state", "1");
                            }}>{t("activeaccount")}</button>
                        </span><br />
                        <span>
                            <button className="button-register" style={{ paddingBottom: "5px" }} variant="text" onClick={() => {
                                setState("2");
                                localStorage.setItem("state", "2");
                            }}>{t("forgetpassword")}</button></span>
                    </Box>
                </div>
            </div>
            <InfoPopup />
        </>
    );
}
